import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/HomePage.vue'
import LegalNoticeEn from './views/legalNotices/en.vue'
import LegalNoticeDe from './views/legalNotices/de.vue'
import LegalNoticePt from './views/legalNotices/pt.vue'
import LegalNoticeFr from './views/legalNotices/fr.vue'
import LegalNoticePl from './views/legalNotices/pl.vue'
import LegalNoticeNl from './views/legalNotices/nl.vue'
import LegalNoticeUk from './views/legalNotices/uk.vue'
import LegalNoticeEs from './views/legalNotices/es.vue'
import LegalNoticeRu from './views/legalNotices/ru.vue'
import PrivatePolicyEn from './views/privatePolicy/en.vue'
import PrivatePolicyDe from './views/privatePolicy/de.vue'
import PrivatePolicyPt from './views/privatePolicy/pt.vue'
import PrivatePolicyFr from './views/privatePolicy/fr.vue'
import PrivatePolicyPl from './views/privatePolicy/pl.vue'
import PrivatePolicyNl from './views/privatePolicy/nl.vue'
import PrivatePolicyUk from './views/privatePolicy/uk.vue'
import PrivatePolicyEs from './views/privatePolicy/es.vue'
import PrivatePolicyRu from './views/privatePolicy/ru.vue'
import appPrivatePolicyEn from './views/privatePolicy/en.vue'
import appPrivatePolicyDe from './views/privatePolicy/de.vue'
import appPrivatePolicyPt from './views/privatePolicy/pt.vue'
import appPrivatePolicyFr from './views/privatePolicy/fr.vue'
import appPrivatePolicyPl from './views/privatePolicy/pl.vue'
import appPrivatePolicyNl from './views/privatePolicy/nl.vue'
import appPrivatePolicyUk from './views/privatePolicy/uk.vue'
import appPrivatePolicyEs from './views/privatePolicy/es.vue'
import appPrivatePolicyRu from './views/privatePolicy/ru.vue'
import KKBB from './views/kkbb/campagne.vue'
import actualityEn from './views/actuality/en.vue'
import actualityDe from './views/actuality/de.vue'
import actualityPt from './views/actuality/pt.vue'
import actualityFr from './views/actuality/fr.vue'
import actualityPl from './views/actuality/pl.vue'
import actualityNl from './views/actuality/nl.vue'
import actualityUk from './views/actuality/uk.vue'
import actualityEs from './views/actuality/es.vue'
import actualityRu from './views/actuality/ru.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/',
      name: 'kkbb',
      component: Home
    },
    {
      path: '/legalnotice/en',
      name: 'legalnoticeEn',
      component: LegalNoticeEn
    },
    {
      path: '/legalnotice/fr',
      name: 'legalnoticeFr',
      component: LegalNoticeFr
    },
    {
      path: '/legalnotice/de',
      name: 'LegalNoticeDe',
      component: LegalNoticeDe
    },
    {
      path: '/legalnotice/pt',
      name: 'LegalNoticePt',
      component: LegalNoticePt
    },
    {
      path: '/legalnotice/pl',
      name: 'LegalNoticePl',
      component: LegalNoticePl
    },
    {
      path: '/legalnotice/nl',
      name: 'LegalNoticeNl',
      component: LegalNoticeNl
    },
    {
      path: '/legalnotice/uk',
      name: 'LegalNoticeUk',
      component: LegalNoticeUk
    },
    {
      path: '/legalnotice/es',
      name: 'LegalNoticeEs',
      component: LegalNoticeEs
    },
    {
      path: '/legalnotice/ru',
      name: 'LegalNoticeRu',
      component: LegalNoticeRu
    },
    {
      path: '/actuality/en',
      name: 'actualityEn',
      component: actualityEn
    },
    {
      path: '/actuality/fr',
      name: 'actualityFr',
      component: actualityFr
    },
    {
      path: '/actuality/de',
      name: 'actualityDe',
      component: actualityDe
    },
    {
      path: '/actuality/pt',
      name: 'actualityPt',
      component: actualityPt
    },
    {
      path: '/actuality/pl',
      name: 'actualityPl',
      component: actualityPl
    },
    {
      path: '/actuality/nl',
      name: 'actualityNl',
      component: actualityNl
    },
    {
      path: '/actuality/uk',
      name: 'actualityUk',
      component: actualityUk
    },
    {
      path: '/actuality/es',
      name: 'actualityEs',
      component: actualityEs
    },
    {
      path: '/actuality/ru',
      name: 'actualityRu',
      component: actualityRu
    },
    {
      path: '/privatepolicy/en',
      name: 'PrivatePolicyEn',
      component: PrivatePolicyEn
    },
    {
      path: '/privatepolicy/de',
      name: 'PrivatePolicyDe',
      component: PrivatePolicyDe
    },
    {
      path: '/privatepolicy/fr',
      name: 'PrivatePolicyFr',
      component: PrivatePolicyFr
    },
    {
      path: '/privatepolicy/pt',
      name: 'PrivatePolicyPt',
      component: PrivatePolicyPt
    },
    {
      path: '/privatepolicy/pl',
      name: 'PrivatePolicyPl',
      component: PrivatePolicyPl
    },
    {
      path: '/privatepolicy/nl',
      name: 'PrivatePolicyNl',
      component: PrivatePolicyNl
    },
    {
      path: '/privatepolicy/uk',
      name: 'PrivatePolicyUk',
      component: PrivatePolicyUk
    },
    {
      path: '/privatepolicy/es',
      name: 'PrivatePolicyEs',
      component: PrivatePolicyEs
    },
    {
      path: '/privatepolicy/ru',
      name: 'PrivatePolicyRu',
      component: PrivatePolicyRu
    },
    {
      path: '/privatepolicy/*',
      name: 'PrivatePolicy',
      component: PrivatePolicyEn
    },
    {
      path: '/privacy_policy',
      name: 'PrivatePolicy',
      component: PrivatePolicyEn
    },
    {
      path: '/privacy-policy',
      name: 'PrivatePolicy',
      component: PrivatePolicyEn
    },
    {
      path: '/appprivatepolicy/en',
      name: 'appPrivatePolicyEn',
      component: appPrivatePolicyEn
    },
    {
      path: '/appprivatepolicy/de',
      name: 'appPrivatePolicyDe',
      component: appPrivatePolicyDe
    },
    {
      path: '/appprivatepolicy/fr',
      name: 'appPrivatePolicyFr',
      component: appPrivatePolicyFr
    },
    {
      path: '/appprivatepolicy/pt',
      name: 'appPrivatePolicyPt',
      component: appPrivatePolicyPt
    },
    {
      path: '/appprivatepolicy/pl',
      name: 'appPrivatePolicyPl',
      component: appPrivatePolicyPl
    },
    {
      path: '/appprivatepolicy/nl',
      name: 'appPrivatePolicyNl',
      component: appPrivatePolicyNl
    },
    {
      path: '/appprivatepolicy/uk',
      name: 'appPrivatePolicyUk',
      component: appPrivatePolicyUk
    },
    {
      path: '/appprivatepolicy/es',
      name: 'appPrivatePolicyEs',
      component: appPrivatePolicyEs
    },
    {
      path: '/appprivatepolicy/ru',
      name: 'appPrivatePolicyRu',
      component: appPrivatePolicyRu
    },
    {
      path: '/appprivatepolicy/*',
      name: 'appPrivatePolicy',
      component: appPrivatePolicyEn
    },
    {
      path: '/appprivatepolicy',
      name: 'appPrivatePolicy',
      component: appPrivatePolicyEn
    },
    {
      path: '/appprivate-policy',
      name: 'appPrivatePolicy',
      component: appPrivatePolicyEn
    },
    {
      path: '/legal-notice',
      name: 'LegalNotice',
      component: LegalNoticeEn
    },
    {
      path: '/legalnotice/*',
      name: 'legalnoticeDefault',
      component: LegalNoticeEn
    },
    {
      path: '/actuality/*',
      name: 'actualityDefault',
      component: actualityEn
    },
    {
      path: '/*',
      name: 'home',
      component: Home
    }
  ]
})
